export const seededPseudoRandom = (seed: string): number => {
  let sum = 0;
  for (let i = 0; i < seed.length; i++) {
    sum += seed.charCodeAt(i);
  }
  const x = Math.sin(sum++) * 10000;
  return x - Math.floor(x);
};

export const getRandomColor = (seed: string): string => {
  const colors = [
    "#999999",
    "#E69F00",
    "#56B4E9",
    "#009E73",
    "#F0E442",
    "#0072B2",
    "#D55E00",
    "#CC79A7",
  ]; //https://stackoverflow.com/questions/65013406/how-to-generate-30-distinct-colors-that-are-color-blind-friendly
  return colors[Math.floor(seededPseudoRandom(seed) * colors.length)] ?? "#999999";
};

export const getInitials = (name: string): string | undefined => {
  let initials: string;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      (nameSplit[0] ?? "").substring(0, 1) + (nameSplit[nameLength - 1] ?? "").substring(0, 1);
  } else if (nameLength === 1) {
    initials = (nameSplit[0] ?? "").substring(0, 1);
  } else return;

  return initials.toUpperCase();
};

export const createImageFromInitials = (
  size: number,
  name: string | null,
  color: string
): string | undefined => {
  if (name == null) return;
  const initials = getInitials(name);
  if (!initials) return;

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return;

  canvas.width = canvas.height = size;

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, size, size);

  context.fillStyle = `${color}`;
  context.fillRect(0, 0, size, size);

  context.fillStyle = "#FFFFFF";
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.font = `${size / 3.2}px Nunito`;
  context.fillText(initials, size / 2, size / 2 + 20);

  return canvas.toDataURL();
};
